import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { getReportFile, GetReportFileRequest } from "@/api";

// although this is a GET, we use a mutation because we need to give it an input parameter
export function useReportFile() {
  return useMutation({
    mutationFn: async (request: GetReportFileRequest) => {
      const result = await getReportFile(request);
      if (result.err) {
        console.error(result.val.devMessage);
        toast.error("Error al obtener el archivo del reporte", {
          description: result.val.message,
        });
        throw new Error(result.val.message);
      }
      return result.val;
    },
  });
}
